import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  getOrgList,
  getOrg,
  useOrgList,
  useOrg,
  init,
  fetch,
  createOrg,
  updateOrg,
};

let g_orgList: any[] = [];

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  addChangeListener(callback);
  return () => {
    removeChangeListener(callback);
  };
}
function init(done) {
  done?.();
}
function getOrgList() {
  return g_orgList;
}
function getOrg(org_id: number) {
  return g_orgList.find((org) => org.org_id === org_id);
}
export function useOrgList() {
  return React.useSyncExternalStore(_subscribe, getOrgList);
}
export function useOrg(org_id: number) {
  const _get = React.useCallback(() => getOrg(org_id), [org_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
function fetch(done?: (err: any) => void) {
  const opts = { url: `/admin/1/org` };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('OrgStore.fetch: err:', err, body);
    } else {
      if (!util.deepEqual(g_orgList, body.org_list)) {
        g_orgList = body.org_list;
        _emit('update');
      }
    }
    done?.(err);
  });
}
function createOrg(params: any, done: (err: any, org_id?: any) => void) {
  const opts = {
    url: `/admin/1/org`,
    body: {
      org_name: params.org_name,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('OrgStore.createOrg: post err:', err, body);
    }
    done(err, body?.org_id);
  });
}
function updateOrg(params: any, done: (err?: any) => void) {
  const { org_id, ...other } = params;
  const opts = {
    url: `/admin/1/org/${org_id}`,
    body: other,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('OrgStore.createOrg: post err:', err, body);
      done(err);
    } else {
      fetch(() => done());
    }
  });
}
